export default __webpack_public_path__ + "static/media/qb.20f62127.png";